import { DrugManufacturersId } from 'common/types';

export const getDepositName = ({ drugManufacturerId, product }): any | null => {
    return (drugManufacturerId === DrugManufacturersId.MonroeAmericana ||
        drugManufacturerId === DrugManufacturersId.Difarmer) &&
        product?.deposit
        ? product?.deposit
        : null;
};
